import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/api";

export default function AdminLogin({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const inputCls =
    "w-full border border-white/15 bg-brand-slate/60 px-4 py-3.5 text-sm text-white placeholder:text-white/35 outline-none transition focus:border-brand-ice focus:ring-1 focus:ring-brand-ice";

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      toast.success("Accesso effettuato. Benvenuto!");
      onSuccess(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[75vh] items-center justify-center px-5 py-16">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md border border-white/10 bg-brand-card p-8 sm:p-10"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center border border-brand-cyan/40 text-brand-ice">
            <Lock className="h-5 w-5" />
          </span>
          <h1 className="font-display text-3xl font-bold uppercase tracking-tight text-white">
            Area Riservata
          </h1>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-slate-400">
          Accedi con email e password per gestire testi, immagini e album dei lavori del sito.
        </p>

        <div className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="mb-2 block font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="La tua email"
              className={inputCls}
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-2 block font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="La tua password"
              className={inputCls}
              data-testid="admin-login-password"
            />
          </div>
        </div>

        {error && (
          <p className="mt-5 border border-brand-red/50 bg-brand-red/10 px-4 py-3 text-sm text-red-300" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-8 flex w-full items-center justify-center gap-3 bg-brand-cyan px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-brand-teal transition hover:bg-brand-ice disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Accesso in corso...
            </>
          ) : (
            "Accedi"
          )}
        </button>
      </form>
    </div>
  );
}
